import { createFileRoute } from '@tanstack/react-router'
import { Header } from '@/components/Header'
import { Footer } from '@/components/Footer'
import {
  BillingSection,
  ProviderTiersCta,
  ProviderTiersFaq,
  ProviderTiersHero,
  RoutingSection,
  TierDetailsSection,
} from '@/features/provider-tiers/components'
import { providerTiersFaqs } from '@/features/provider-tiers/data/providerTiersContent'
import { generateLinks, generateMetaTags, routeSEO } from '@/lib/seo'
import {
  getBreadcrumbSchema,
  getFAQSchema,
  renderJsonLd,
} from '@/lib/structured-data'

export const Route = createFileRoute('/provider-tiers')({
  head: () => ({
    meta: generateMetaTags(routeSEO['/provider-tiers']),
    links: generateLinks(routeSEO['/provider-tiers']),
  }),
  component: ProviderTiersPage,
})

function ProviderTiersPage() {
  return (
    <div className="relative min-h-screen flex flex-col overflow-x-clip bg-[var(--color-bg-primary)]">
      {/* Structured Data — the FAQ schema is built from the same list the
          page renders, so the two can't drift apart. */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: renderJsonLd(getFAQSchema([...providerTiersFaqs])),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: renderJsonLd(
            getBreadcrumbSchema([
              { name: 'Home', url: '/' },
              { name: 'Provider Tiers', url: '/provider-tiers' },
            ]),
          ),
        }}
      />

      <Header />

      <main className="flex flex-col">
        <ProviderTiersHero />
        <RoutingSection />
        <TierDetailsSection />
        <BillingSection />
        <ProviderTiersFaq />
        <ProviderTiersCta />
      </main>

      <Footer />
    </div>
  )
}
